import { clamp, isNil } from 'lodash';
import { AppState } from 'types';
import { Integer } from 'helpers';

export function LoadingAction(state: AppState, payload: Partial<AppState>) {
	const { loading } = payload;
	const n = Integer(loading?.loading);
	const valid = clamp(state.loading.loading + n, 0, Number.MAX_SAFE_INTEGER);
	const message = isNil(loading?.message) ? state.loading.message : `${loading?.message}`.trim();
	return {
		...state,
		loading: {
			...state.loading,
			loading: valid,
			message
		}
	};
}
